"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTDropMarket = void 0;
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
exports.NFTDropMarket = [
    {
        inputs: [
            { internalType: 'address payable', name: 'treasury', type: 'address' },
            { internalType: 'address', name: 'feth', type: 'address' },
            { internalType: 'address', name: 'router', type: 'address' },
            { internalType: 'address', name: 'marketUtils', type: 'address' },
            { internalType: 'address', name: 'worldsNft', type: 'address' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'DropMarketLibrary_General_Availability_Start_Time_Has_Expired',
        type: 'error',
    },
    {
        inputs: [],
        name: 'DropMarketLibrary_Mint_Permission_Required',
        type: 'error',
    },
    {
        inputs: [],
        name: 'DropMarketLibrary_Only_Callable_By_Collection_Admin',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'maxTime', type: 'uint256' }],
        name: 'DropMarketLibrary_Time_Too_Far_In_The_Future',
        type: 'error',
    },
    {
        inputs: [],
        name: 'FETHNode_FETH_Address_Is_Not_A_Contract',
        type: 'error',
    },
    { inputs: [], name: 'FETHNode_Only_FETH_Can_Transfer_ETH', type: 'error' },
    {
        inputs: [
            { internalType: 'uint256', name: 'expectedValueAmount', type: 'uint256' },
        ],
        name: 'FethNode_Too_Much_Value_Provided',
        type: 'error',
    },
    {
        inputs: [],
        name: 'FoundationTreasuryNode_Address_Is_Not_A_Contract',
        type: 'error',
    },
    {
        inputs: [],
        name: 'FoundationTreasuryNode_Caller_Not_Admin',
        type: 'error',
    },
    {
        inputs: [],
        name: 'FoundationTreasuryNode_Caller_Not_Operator',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketCore_Collection_Already_Listed_For_Sale',
        type: 'error',
    },
    { inputs: [], name: 'NFTDropMarketCore_Invalid_Merkle_Root', type: 'error' },
    {
        inputs: [],
        name: 'NFTDropMarketCore_Must_Have_Available_Supply',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketCore_Must_Support_Collection_Mint_Interface',
        type: 'error',
    },
    { inputs: [], name: 'NFTDropMarketCore_Must_Support_ERC721', type: 'error' },
    {
        inputs: [{ internalType: 'uint256', name: 'startTime', type: 'uint256' }],
        name: 'NFTDropMarketDutchAuction_Auction_Has_Not_Started_Yet',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Auction_Not_Found',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'endTime', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'numberStillAvailable',
                type: 'uint256',
            },
        ],
        name: 'NFTDropMarketDutchAuction_Clearing_Price_Not_Reached',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Creator_Revenue_Has_Already_Been_Withdrawn',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'maxTime', type: 'uint256' }],
        name: 'NFTDropMarketDutchAuction_End_Time_Too_Far_In_The_Future',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Invalid_Nft_Recipient',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Limit_Per_Account_Must_Be_Set',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Min_Price_Must_Be_Less_Than_Max_Price',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Mint_Count_Must_Be_Greater_Than_Zero',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'currentMintCount', type: 'uint256' },
            { internalType: 'uint256', name: 'limitPerAccount', type: 'uint256' },
        ],
        name: 'NFTDropMarketDutchAuction_Mint_Exceeds_Limit_Per_Account',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Must_Have_Available_Supply',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Nothing_To_Rebate_At_This_Time',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Sale_Duration_Must_Be_Greater_Than_Zero',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketDutchAuction_Start_Time_Must_Not_Be_In_The_Past',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'limitPerAccount', type: 'uint256' },
        ],
        name: 'NFTDropMarketFixedPriceSale_Cannot_Buy_More_Than_Limit',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'earlyAccessStartTime',
                type: 'uint256',
            },
        ],
        name: 'NFTDropMarketFixedPriceSale_Early_Access_Not_Open',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketFixedPriceSale_Early_Access_Start_Time_Has_Expired',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketFixedPriceSale_General_Access_Is_Open',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'generalAvailabilityStartTime',
                type: 'uint256',
            },
        ],
        name: 'NFTDropMarketFixedPriceSale_General_Access_Not_Open',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketFixedPriceSale_Invalid_Merkle_Proof',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketFixedPriceSale_Limit_Per_Account_Must_Be_Set',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketFixedPriceSale_Must_Be_Listed_For_Sale',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NFTDropMarketFixedPriceSale_Must_Have_Non_Zero_Early_Access_Duration',
        type: 'error',
    },
    { inputs: [], name: 'NFTDropMarket_NFT_Already_Minted', type: 'error' },
    { inputs: [], name: 'NFTMarketFees_Invalid_Protocol_Fee', type: 'error' },
    {
        inputs: [],
        name: 'NFTMarketFees_Market_Utils_Is_Not_A_Contract',
        type: 'error',
    },
    {
        inputs: [],
        name: 'RouterContextSingle_Address_Is_Not_A_Contract',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'uint8', name: 'bits', type: 'uint8' },
            { internalType: 'uint256', name: 'value', type: 'uint256' },
        ],
        name: 'SafeCastOverflowedUintDowncast',
        type: 'error',
    },
    {
        inputs: [],
        name: 'StringsLibrary_Required_String_Is_Empty',
        type: 'error',
    },
    { inputs: [], name: 'TxDeadline_Tx_Deadline_Expired', type: 'error' },
    {
        inputs: [],
        name: 'WorldsNftNode_Worlds_NFT_Is_Not_A_Contract',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'merkleRoot',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'merkleTreeUri',
                type: 'string',
            },
        ],
        name: 'AddMerkleRootToFixedPriceSale',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'buyReferrer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'buyReferrerFee',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'buyReferrerSellerFee',
                type: 'uint256',
            },
        ],
        name: 'BuyReferralPaid',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'price',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'limitPerAccount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'generalAvailabilityStartTime',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'earlyAccessStartTime',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'merkleRoot',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'merkleTreeUri',
                type: 'string',
            },
        ],
        name: 'CreateFixedPriceSale',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'seller',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'maxPrice',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'minPrice',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'limitPerAccount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'startTime',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'endTime',
                type: 'uint256',
            },
        ],
        name: 'CreateLinearDutchAuction',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'firstTokenId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'nftRecipient',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'fixedProtocolFeeInWei',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'nftCount',
                type: 'uint256',
            },
        ],
        name: 'FixedProtocolFeePaid',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'buyer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'pricePaidPerNft',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'count',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'firstTokenId',
                type: 'uint256',
            },
        ],
        name: 'MintFromDutchAuction',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'buyer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'pricePaidPerNft',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'count',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'firstTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'totalFees',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'creatorRev',
                type: 'uint256',
            },
        ],
        name: 'MintFromDutchAuctionV2',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'buyer',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'firstTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'count',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'totalFees',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'creatorRev',
                type: 'uint256',
            },
        ],
        name: 'MintFromFixedPriceDrop',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'buyer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'rebate',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'currentPricePerNft',
                type: 'uint256',
            },
        ],
        name: 'RebateBuyerFromDutchAuction',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'sellerReferrer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'sellerReferrerFee',
                type: 'uint256',
            },
        ],
        name: 'SellerReferralPaid',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'nftContract',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'clearingPrice',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'totalMintedCount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'totalFees',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'creatorRev',
                type: 'uint256',
            },
        ],
        name: 'WithdrawCreatorRevenueFromDutchAuction',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'WithdrawalToFETH',
        type: 'event',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'bytes32', name: 'merkleRoot', type: 'bytes32' },
            { internalType: 'string', name: 'merkleTreeUri', type: 'string' },
        ],
        name: 'addMerkleRootToFixedPriceSale',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'price', type: 'uint256' },
            { internalType: 'uint256', name: 'limitPerAccount', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'generalAvailabilityStartTime',
                type: 'uint256',
            },
            { internalType: 'uint256', name: 'txDeadlineTime', type: 'uint256' },
        ],
        name: 'createFixedPriceSale',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'price', type: 'uint256' },
            { internalType: 'uint256', name: 'limitPerAccount', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'generalAvailabilityStartTime',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'earlyAccessStartTime',
                type: 'uint256',
            },
            { internalType: 'bytes32', name: 'merkleRoot', type: 'bytes32' },
            { internalType: 'string', name: 'merkleTreeUri', type: 'string' },
            { internalType: 'uint256', name: 'txDeadlineTime', type: 'uint256' },
        ],
        name: 'createFixedPriceSaleWithEarlyAccessAllowlist',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'maxPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'minPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'limitPerAccount', type: 'uint256' },
            { internalType: 'uint256', name: 'startTime', type: 'uint256' },
            { internalType: 'uint256', name: 'saleDuration', type: 'uint256' },
        ],
        name: 'createLinearDutchAuctionV2',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getApprovedRouterAddress',
        outputs: [{ internalType: 'address', name: 'router', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'getAvailableCountFromFixedPriceSale',
        outputs: [
            {
                internalType: 'uint256',
                name: 'numberThatCanBeMinted',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address', name: 'buyer', type: 'address' },
        ],
        name: 'getBuyerInfoFromDutchAuction',
        outputs: [
            {
                internalType: 'uint256',
                name: 'outstandingRebateBalance',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'numberThatCanBeMinted',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'nftContract', type: 'address' }],
        name: 'getDutchAuctionV2',
        outputs: [
            { internalType: 'uint256', name: 'maxPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'minPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'limitPerAccount', type: 'uint256' },
            { internalType: 'uint256', name: 'startTime', type: 'uint256' },
            { internalType: 'uint256', name: 'endTime', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'totalAvailableSupply',
                type: 'uint256',
            },
            { internalType: 'uint256', name: 'totalMintedCount', type: 'uint256' },
            { internalType: 'uint256', name: 'lastSalePrice', type: 'uint256' },
            { internalType: 'uint256', name: 'currentPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'mintFeePerNftInWei', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'address payable', name: 'seller', type: 'address' },
            { internalType: 'uint256', name: 'price', type: 'uint256' },
            { internalType: 'address payable', name: 'buyReferrer', type: 'address' },
            {
                internalType: 'uint16',
                name: 'sellerReferrerTakeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        name: 'getFees',
        outputs: [
            { internalType: 'uint256', name: 'protocolFeeAmount', type: 'uint256' },
            {
                internalType: 'address payable[]',
                name: 'creatorRecipients',
                type: 'address[]',
            },
            { internalType: 'uint256[]', name: 'creatorShares', type: 'uint256[]' },
            { internalType: 'uint256', name: 'sellerRev', type: 'uint256' },
            { internalType: 'uint256', name: 'buyReferrerFee', type: 'uint256' },
            { internalType: 'uint256', name: 'sellerReferrerFee', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'uint256', name: 'price', type: 'uint256' },
        ],
        name: 'getFeesAndRecipients',
        outputs: [
            { internalType: 'uint256', name: 'totalFees', type: 'uint256' },
            { internalType: 'uint256', name: 'creatorRev', type: 'uint256' },
            {
                internalType: 'address payable[]',
                name: 'creatorRecipients',
                type: 'address[]',
            },
            { internalType: 'uint256[]', name: 'creatorShares', type: 'uint256[]' },
            { internalType: 'uint256', name: 'sellerRev', type: 'uint256' },
            { internalType: 'address payable', name: 'seller', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getFethAddress',
        outputs: [
            { internalType: 'address', name: 'fethAddress', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'bytes32', name: 'merkleRoot', type: 'bytes32' },
        ],
        name: 'getFixedPriceSaleEarlyAccessAllowlistSupported',
        outputs: [{ internalType: 'bool', name: 'supported', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'nftContract', type: 'address' }],
        name: 'getFixedPriceSaleV2',
        outputs: [
            { internalType: 'address payable', name: 'seller', type: 'address' },
            { internalType: 'uint256', name: 'price', type: 'uint256' },
            { internalType: 'uint256', name: 'limitPerAccount', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'numberOfTokensAvailableToMint',
                type: 'uint256',
            },
            { internalType: 'bool', name: 'marketCanMint', type: 'bool' },
            {
                internalType: 'uint256',
                name: 'generalAvailabilityStartTime',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'earlyAccessStartTime',
                type: 'uint256',
            },
            { internalType: 'uint256', name: 'mintFeePerNftInWei', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getFoundationTreasury',
        outputs: [
            {
                internalType: 'address payable',
                name: 'treasuryAddress',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getMarketUtilsAddress',
        outputs: [
            { internalType: 'address', name: 'marketUtilsAddress', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'time', type: 'uint256' },
        ],
        name: 'getPriceAtTimeForDutchAuction',
        outputs: [{ internalType: 'uint256', name: 'price', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'pricePerQuantity', type: 'uint256' },
            { internalType: 'uint256', name: 'tokenQuantity', type: 'uint256' },
        ],
        name: 'getRevenueDistributionForMint',
        outputs: [
            { internalType: 'uint256', name: 'creatorRevenue', type: 'uint256' },
            { internalType: 'uint256', name: 'protocolFee', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'nftContract', type: 'address' }],
        name: 'getSellerInfoFromDutchAuction',
        outputs: [
            { internalType: 'address', name: 'seller', type: 'address' },
            {
                internalType: 'bool',
                name: 'creatorRevenueReadyForWithdrawal',
                type: 'bool',
            },
            {
                internalType: 'bool',
                name: 'creatorRevenueHasBeenWithdrawn',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'totalFundsPendingDistribution',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getSellerOf',
        outputs: [
            { internalType: 'address payable', name: 'seller', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getWorldsNftAddress',
        outputs: [{ internalType: 'address', name: 'worldsNft', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'count', type: 'uint256' },
            { internalType: 'address', name: 'nftRecipient', type: 'address' },
        ],
        name: 'mintFromDutchAuctionV2',
        outputs: [
            { internalType: 'uint256', name: 'firstTokenId', type: 'uint256' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint16', name: 'count', type: 'uint16' },
            { internalType: 'address', name: 'nftRecipient', type: 'address' },
            { internalType: 'address payable', name: 'buyReferrer', type: 'address' },
        ],
        name: 'mintFromFixedPriceSaleV2',
        outputs: [
            { internalType: 'uint256', name: 'firstTokenId', type: 'uint256' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'count', type: 'uint256' },
            { internalType: 'address', name: 'nftRecipient', type: 'address' },
            { internalType: 'address payable', name: 'buyReferrer', type: 'address' },
            { internalType: 'bytes32[]', name: 'proof', type: 'bytes32[]' },
        ],
        name: 'mintFromFixedPriceSaleWithEarlyAccessAllowlistV2',
        outputs: [
            { internalType: 'uint256', name: 'firstTokenId', type: 'uint256' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address payable', name: 'buyer', type: 'address' },
        ],
        name: 'rebateBuyerFromDutchAuction',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'nftContract', type: 'address' }],
        name: 'withdrawCreatorRevenueFromDutchAuction',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    { stateMutability: 'payable', type: 'receive' },
];
//# sourceMappingURL=NFTDropMarket.generated.js.map